import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequiredFieldMsgComponent } from './required-field-msg.component';




@NgModule({
  declarations: [RequiredFieldMsgComponent],
  imports: [
    CommonModule
  ],
  exports:[RequiredFieldMsgComponent]
})
export class RequiredFieldMsgModule { }
